<div class="keen-slider" #sliderRef>
  <ng-content></ng-content>
</div>
